export const checkForIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export const filterItems = (items, filters) => {
    //output: array of items that match filters

    console.log(filters);

    /*
    filters: [
      { prop: 'propname', values: []}
    ]
    */

    return items.reduce((acc1, item) => {

      //console.log(item);

      const doesMatch = filters.reduce((acc2, filter, i) => {

        //does item have this prop
        if (!item.hasOwnProperty(filter.prop)) {
          //console.log('- does not have prop: ' + filter.prop);
          acc2 = false;
          return acc2;
        }
        //console.log('- has prop: ' + filter.prop);

        //ensure filter.values is an array
        filter.values = !Array.isArray(filter.values) ? [ filter.values ] : filter.values;

        //console.log('- filter vals as array: ');
        //console.log(filter.values);

        //get item[prop] values
        let itemValues = item[filter.prop];

        //console.log('- item vals (raw): ');
        //console.log(itemValues);

        //ensure prop value is array
        itemValues = !Array.isArray(itemValues) ? [ itemValues ] : itemValues;

        //console.log('- item vals as array: ');
        //console.log("ITEM VALUES");
        //if (i==0) console.log(itemValues);

        //check for intersection
        const numMatches = itemValues.filter(x => {
          //check if array or string when filtering, if array get last item and use as string
          x = (Array.isArray(x)) ? x[x.length-1] : x;
          return filter.values.includes(x);
        }).length; 
        //console.log('- num matches: ' + numMatches);
        
        //if filter not matched, and still true, mark as false
        if (numMatches <= 0) acc2 = false;

        //return
        return acc2;

      }, true); //assume matches
    
      //console.log(doesMatch);

      if (doesMatch) acc1.push(item);

      return acc1;

    }, []);
}